module.exports = __webpack_public_path__ + "static/media/question.3d9243b9.svg";